import enUS from '@/locales/en-US.json';
import enGB from '@/locales/en-GB.json';
import enCA from '@/locales/en_CA.json';
import enAU from '@/locales/en_AU.json';
import esES from '@/locales/es-ES.json';
import frFR from '@/locales/fr-FR.json';
import deDE from '@/locales/de-DE.json';
import zhHans from '@/locales/zh-Hans.json';

/** All supported locale message maps. Managed by SimpleLocalize going forward. */
export const LOCALE_MESSAGES = {
  'en-US': enUS,
  'en-GB': enGB,
  'en-CA': enCA,
  'en-AU': enAU,
  'es-ES': esES,
  'fr-FR': frFR,
  'de-DE': deDE,
  'zh-Hans': zhHans,
};

const FALLBACK_LOCALE = 'en-US';

/**
 * Returns a `t(key)` translation function for the given locale.
 * Missing keys fall back to the en-US locale, then to the raw key string.
 *
 * @param {string} [locale='en-US'] - BCP 47 locale code, e.g. 'en-GB'
 * @returns {{ t: (key: string) => string, locale: string }}
 *
 * @example
 * const { t } = getTranslations('en-GB');
 * t('nav.home')       // 'Home'
 * t('charts.noData')  // falls back to en-US: 'No data available'
 * t('nonexistent')    // returns key: 'nonexistent'
 */
export function getTranslations(locale = FALLBACK_LOCALE) {
  const messages = LOCALE_MESSAGES[locale] ?? LOCALE_MESSAGES[FALLBACK_LOCALE];
  const fallback = LOCALE_MESSAGES[FALLBACK_LOCALE];

  function t(key) {
    if (messages && key in messages) return messages[key];
    if (fallback && key in fallback) return fallback[key];
    return key;
  }

  return { t, locale };
}
